'use client';

import { useTheme } from 'next-themes';

import { Moon, Sun } from '@/assets';
import { Button } from '@/components';
import { cn } from '@/lib';

export const ThemeToggle = ({ className }) => {
  const { setTheme } = useTheme();

  const handleThemeChange = () => {
    setTheme((prev) => {
      return prev == 'light' ? 'dark' : 'light';
    });
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={handleThemeChange}
      className={cn('shrink-0 [&_svg]:size-[1.2rem]', className)}
    >
      <Sun className="scale-100 rotate-0 dark:scale-0 dark:-rotate-90" />
      <Moon className="absolute scale-0 rotate-90 dark:scale-100 dark:rotate-0" />
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
};
